import { Component, Input } from "@angular/core";

@Component({
  selector: "[input-wrapper]",
  templateUrl: "./input-wrapper.component.html"
})
export class InputWrapperComponent {
  @Input() labelName = "";
  @Input() labelFor = "";
}
